/**
 * SAML SSO Configuration Admin Page
 */

import React from 'react';
import { SAMLSSOManager } from '@/components/admin/SAMLSSOManager';
import { PageHeader, PageContainer } from '@/components/weavein';

export default function SAMLSSOConfigPage() {
  return (
    <div className="flex h-full flex-col">
      <PageHeader
        eyebrow="Admin · Integrations"
        title="SSO Configuration"
        description="Configure SAML 2.0 Single Sign-On for federated authentication with LANES LA or other Identity Providers."
      />
      <PageContainer>
        <SAMLSSOManager />
      </PageContainer>
    </div>
  );
}
